<p-calendar #Calendar
  tabindex="-1"
  showButtonBar="true"
  yearRange="1900:2100"
  dateFormat="dd M yy"
  placeholder="{{placeholder}}"
  icon="icon__Calendar"
  [inputStyleClass]="'form-control input-with-button-override text-override '+inputClass"
  [disabled]="disable"
  [panelStyleClass]="(selectionMode && selectionMode === 'range') ? 'hide-month-nav range-pick': 'hide-month-nav'"
  [appendTo]="appendTo ? appendTo : 'body'"
  [showIcon]="showIcon? showIcon : true"
  [monthNavigator]="true"
  [yearNavigator]="yearNavigator? yearNavigator : true"
  [showTime]="showTime?showTime:false"
  [dataType]="dataType"
  [maxDate]="maxDate"
  [minDate]="minDate"
  [formControl]="calender"
  [inline]="inline"
  [selectionMode]="selectionMode?selectionMode:'single'"
  (onFocus)="onFocus.emit($event)"
  (onBlur)="blured.emit($event);"
  (onSelect)="onSelect($event)"
  (blur)="onBlur()"
  (onClose)="onClickOutside()"
  (onClearClick)="clear()"
>
</p-calendar>
